"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Lazy loads the runtime implementations for a Twig element.
 *
 * @author Eric MORAND <eric.morand@gmail.com>
 */
class TwingFactoryRuntimeLoader {
    constructor(map = new Map()) {
        this.TwingRuntimeLoaderInterfaceImpl = this;
        this.map = map;
    }
    load(class_) {
        if (this.map.has(class_)) {
            let runtimeFactory = this.map.get(class_);
            return runtimeFactory();
        }
    }
}
exports.TwingFactoryRuntimeLoader = TwingFactoryRuntimeLoader;
